import { render, staticRenderFns } from "./CreateCategoryAdmin.vue?vue&type=template&id=02d90b1e&"
import script from "./CreateCategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateCategoryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports